import { Component, OnInit, Input, QueryList, AfterViewInit, ViewChildren, ViewChild } from '@angular/core';
import { PartInfo } from 'src/app/models/partinfo';
import { ProposalService } from 'src/app/services/proposal.service';
import { Observable, of } from 'rxjs';
import { GridData, DataStateChangeEvent } from '@tesla/angular2-tesla-common/grid/grid.models';
import Helper from 'src/app/core/utility/helper';
import { PartBasicInfo } from 'src/app/models/partbasicinfo';
import { DataService } from 'src/app/services/data.service';
import { Router } from '@angular/router';
import { PendingProposalPartInfo } from 'src/app/models/internal/pendingproposalpartinfo';
import { UpdateHotRequestDTO } from 'src/app/models/internal/updatehotrequestdto';
import { ToastService } from 'src/app/services/toaster/toaster.service';
import { Constants } from 'src/app/core/constants';
import { TeslaGridComponent } from '@tesla/angular2-tesla-common/tesla-common';
import { QueryPendingProposalDTO } from 'src/app/models/internal/query-pendingproposal-dto';
import { BaseGridPage } from 'src/app/core/basepages/allbasepages';
import { SearchFilter } from 'src/app/models/internal/searchfilter';
import { tap } from 'rxjs/operators';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { FormGroup, FormBuilder } from '@angular/forms';
import { SourceType } from 'src/app/models/sourcetype';
import { PartSystemDTO } from 'src/app/models/external/partsystem-dto';
import { QueryBaseForPEDTO } from 'src/app/models/internal/query-base-for-pe';
import { FormService } from 'src/app/services/form';
import { AppSettings } from 'src/app/app.settings';
import { TeslaAutocompleteComponent } from '@tesla/angular2-tesla-common/autocomplete/autocomplete.component';
import { NGXLogger } from 'ngx-logger';
import UIHelper from '../../core/utility/ui-helper';

@Component({
    selector: 'app-partlisthotrequest',
    templateUrl: './partlisthotrequest.component.html',
    styleUrls: ['./partlisthotrequest.component.scss'],
})
export class PartlisthotrequestComponent extends BaseGridPage implements OnInit, AfterViewInit {
    appSettings: AppSettings;
    partsToMakeHotRequestList: PartInfo[];
    partInfoList: PartInfo[];
    partSystemList: PartSystemDTO[];
    allItemsCheckBoxSelected: boolean = false;
    updateHotRequestDTO = new UpdateHotRequestDTO();
    makeHotRequest:boolean = true;
    cancelHotRequest:boolean = true;
    public subscribers: any = {};
    filterForm: FormGroup;
    @ViewChildren(TeslaGridComponent) Grids: QueryList<TeslaGridComponent>;
    @ViewChild('SupplierAutoComplete') SupplierAutoComplete: TeslaAutocompleteComponent;
    searchSupplierURL: string;
    sourceTypeList: SourceType[];
    isMarkedHotRequestList: any[] = [];
    public formErrors = {
        SourceTypeId: '',
        PartSystemId: '',
        AtLeastOneFilter: '',
    };

    constructor(
        private dataService: DataService,
        private proposalService: ProposalService,
        private toastService: ToastService,
        localstorageService: LocalstorageService,
        private fb: FormBuilder,
        private FormService: FormService,
        private router: Router,
        logger: NGXLogger,
        appSettings: AppSettings,
        ) {
        super(localstorageService, logger, appSettings);
        this.filterForm = this.fb.group({
            PartNumber: [null],
            SupplierCode: [null],
            SourceTypeId: [null],
            PartSystemId: [null],
            HotRequest: [null],            
            AtLeastOneFilter: [null],
        });

        this.isMarkedHotRequestList.push({ Description: 'Yes', Value: true });
        this.isMarkedHotRequestList.push({ Description: 'No', Value: false });
        this.appSettings = appSettings;
        this.searchSupplierURL = this.appSettings.Packaging2APIUrl + '/externaldata/supplier/all';

    }

    ngOnInit() {
        this.getSourceTypesForPE();
        this.getPartSystemsForPE();
        this.initFilterValues();
    }

    ngAfterViewInit(): void {
        this.subscribers.grids = this.Grids.changes.subscribe(
            (comps: QueryList<TeslaGridComponent>) => {
                if (!this.mainGrid) {
                    this.mainGrid = comps.first;
                    this.mainGrid.dataStateChange
                        .pipe(
                            tap(
                                ({
                                    skip,
                                    take,
                                    sort,
                                }: DataStateChangeEvent) => {
                                    this.skip = skip;
                                    this.pageSize = take;
                                    this.sort = sort;
                                }
                            )
                        )
                        .subscribe(x => this.fillGrid());
                }
            }
        );
    }
    getSourceTypesForPE() {
        query: QueryBaseForPEDTO
        this.dataService.getParentSourceTypes().subscribe((response: any) => {
            if (response && response.Data != null) {
                this.sourceTypeList = response.Data;
            }
        });
    }

    getPartSystemsForPE() {
        this.dataService.getPartSystems().subscribe((response: any) => {
                if (response != null && response.Success) {
                    this.partSystemList = response.Data;
                    // this.partSystemList = this.excludeAlreadyAssignedPartSystems(this.partSystemList);
                }
            });
    }

    fillGrid(): void {
        // const CurrentSupplierCode = this.localstorageService.retrieve(this.locStorage.CurrentSupplierCode);
        this.filter.Skip = this.skip;
        this.filter.Take = this.pageSize;
        this.allItemsCheckBoxSelected = false;
        let queryPendingProposalDTO: QueryPendingProposalDTO = {
            // SupplierCode: CurrentSupplierCode,
            SearchFilter: this.filter,
            HotRequest: null,
        }
        this.getpartsForPE(queryPendingProposalDTO);
    }
    UpdateFilter()
    {
        this.filter.SearchFilterConditions = [];
        this.filter = this.setFilterCondition(this.filter, this.filterForm, "PartNumber", Constants.FILTER_DATATYPE_STRING,  Constants.FILTER_OPERATOR_TYPE_LIKE);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, "SupplierCode", Constants.FILTER_DATATYPE_STRING,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, "SourceTypeId", Constants.FILTER_DATATYPE_NUMBER,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, "PartSystemId", Constants.FILTER_DATATYPE_NUMBER,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
        this.filter = this.setFilterCondition(this.filter, this.filterForm, "HotRequest", Constants.FILTER_DATATYPE_NUMBER,  Constants.FILTER_OPERATOR_TYPE_EQUAL);
    }
    clearFilter()
    {
        this.filterForm.reset();
        this.filter.SearchFilterConditions = [];
    }

    getpartsForPE(queryPendingProposalDTO) {
        this.ValidateForm();
        if (this.filterForm.valid) {

        this.UpdateFilter();
        queryPendingProposalDTO.SearchFilter = this.filter;
        this.dataService.getpartsForPE(queryPendingProposalDTO).subscribe((response: any) => {
            //this.partInfo = response
            if (response != null) {
                this.partsToMakeHotRequestList = response.Data;
                this.gridView = of({
                    data: response.Data,
                    total: response.Total ? response.Total : 0,
                });
            }
        });
    }
    }
    formatDate(unformattedDate: Date) {
        return Helper.formatDate(unformattedDate);
    }
    markAsHotRequest(hotRequestStatus: boolean) {
        // this.proposalService.RefreshPartInfoids([8977]);
        let selectedParts = this.partsToMakeHotRequestList.filter(
            a => a.IsSelected == true
        );
        // this.partInfoIds = Array.prototype.map.call(selectedParts, s => s.Id);
        // this.updateHotRequestDTO.PartInfoIds = Array.prototype.map.call(
        //     selectedParts,
        //     s => s.Id
        // );
        this.partInfoList = selectedParts;
        this.updateHotRequestDTO.PartInfoList = selectedParts;
        this.updateHotRequestDTO.HotRequestStatus = hotRequestStatus;
        // this.proposalService.RefreshpartInfoToBeCreatedList(selectedParts);
        // this.router.navigate(['../', 'proposal']);
        this.dataService
            .makeHotRequest(this.updateHotRequestDTO)
            .subscribe((response: any) => {
                if (response != null) {
                    if(response.Success)
                    {
                    this.toastService.success("Hot Request status " + Constants.SUCCESS_SAVE_GENERIC);
                    this.setAllSelected(false);
                    this.allItemsCheckBoxSelected = false;
                    this.fillGrid();
                    }
                }
            });
    }

    onRowSelectedChange(isSelected: boolean, partInfo: PartInfo) {
        if (isSelected) {
            this.partsToMakeHotRequestList.find(
                a => a.PartNumber == partInfo.PartNumber && partInfo.SupplierCode == a.SupplierCode && a.POUomCode == partInfo.POUomCode && a.SourceTypeId == partInfo.SourceTypeId
            ).IsSelected = true;
            if (
                this.partsToMakeHotRequestList.filter(a => a.IsSelected == true)
                    .length == this.partsToMakeHotRequestList.length
            ) {
                this.allItemsCheckBoxSelected = true;
            }

        } else {
            this.partsToMakeHotRequestList.find(
                a => a.PartNumber == partInfo.PartNumber && partInfo.SupplierCode == a.SupplierCode && a.POUomCode == partInfo.POUomCode && a.SourceTypeId == partInfo.SourceTypeId
            ).IsSelected = false;
            this.allItemsCheckBoxSelected = false;
        }
        var CountForHotRequest=0;
        var CountForNotHotRequest=0;
        this.partsToMakeHotRequestList.forEach(x=>{
            if(x.HotRequest&&x.IsSelected){
                CountForHotRequest++;
            }else if(!x.HotRequest&&x.IsSelected){
                CountForNotHotRequest++;
            }
        })
        if(CountForHotRequest>0&&CountForNotHotRequest>0){
            this.makeHotRequest =true;
            this.cancelHotRequest=true;
        }else if (CountForHotRequest>0){
            this.makeHotRequest = true;
            this.cancelHotRequest = false;
        }else if(CountForNotHotRequest>0){
            this.makeHotRequest = false;
            this.cancelHotRequest = true;
        }else{
            this.makeHotRequest =true;
            this.cancelHotRequest=true;
        }
        // this.proposalService.RefreshpartInfoToBeCreatedList(
        //     this.partsToMakeHotRequestList
        // );
    }

    setAllSelected(isSelected: boolean) {
        // this.partinfoList.map(function(part) {
        //     part.IsSelected = isSelected;
        //     return part;
        // });
        this.partsToMakeHotRequestList.forEach(part => {
            part.IsSelected = isSelected;
        });
        this.proposalService.RefreshpartInfoToBeCreatedList(
            this.partsToMakeHotRequestList
        );
    }
    partSystemChanged(event)
    {

    }
    proposalDraftCreated(part: PendingProposalPartInfo): boolean {
        return part.ProposalId > 0;
    }
    ValidateForm() {
        this.filterForm.controls[
            'AtLeastOneFilter'
        ].setErrors(null);
        var supplierCode = this.filterForm.get('SupplierCode').value;
        var partNumber = this.filterForm.get('PartNumber').value;

        if (!supplierCode && !partNumber) {
            this.filterForm.controls[
                'AtLeastOneFilter'
            ].setErrors({ selectAtLeastOneFilter_HotRequests: true });
            // this.formErrors.partNumberSelection = "Please select at least one part number";
        }
        this.formErrors = this.FormService.validateForm(
            <FormGroup>this.filterForm,
            this.formErrors
        );
    }

    onEmptySupplierCode(eventObj: any): void {
        this.filterForm.controls['SupplierCode'].patchValue(null);
        this.SupplierAutoComplete.list = [];
        if (this.filter != null && this.filter.SearchFilterConditions != null && this.filter.SearchFilterConditions.findIndex(x => x.Field === 'SupplierCode') >= 0) {
            this.filter.SearchFilterConditions.splice(this.filter.SearchFilterConditions.findIndex(x => x.Field === 'SupplierCode'), 1);
        }
    }

    setSourceTypeDesc(dataItem: PartInfo){
        if (dataItem.ParentSourceTypeId) {
            const source = this.sourceTypeList.find(x => x.Id === dataItem.ParentSourceTypeId);
            dataItem.ParentSourceTypeDescription = source.Description;
            dataItem.SourceTypeName = source.Name;
        } else {
            dataItem.ParentSourceTypeDescription = dataItem.SourceTypeDescription;
        }
        return   dataItem.ParentSourceTypeDescription + '(' + dataItem.SourceTypeName + ')';
     }
}
